<template>
  <form @submit.prevent="onSubmit">
    <div class="mb-base">
      <label class="vs-input--label">Дата:</label>
      <elsa-v-datepicker
        v-model="date"
        ref="saveExistUserDate"
        class="w-full"
      />
    </div>
    <div class="vx-row">
      <div class="vx-col w-full text-right">
        <vs-button @click="onCancel" type="flat">Отменить</vs-button>
        <vs-button button="submit">Сохранить</vs-button>
      </div>
    </div>
  </form>
</template>

<script>
import formatDate from "@/client/helpers/formatDate";
import modal      from "../../../mixins/modalContext";

export default {
  name:    "DateSelectPopup",
  mixins:  [modal],
  data() {
    return {
      date: null,
    };
  },
  methods: {
    onCancel() {
      this.modalReject();
    },
    onSubmit() {
      this.modalResolve(formatDate(this.date, 'yyyy-MM-dd'));
    },
  },
};
</script>

<style scoped>

</style>
